---@meta

---@class AI
---@field inferTag fun(message: string): string, string
---@field confirmTag fun(message: string, tag: string): boolean, string
---@field introduce fun(streamerLogin: string): IntroductoryPair, string
---@field respond fun(message: string, history: table): string[], string
---@field reason fun(message: string, history: table): ReasonedResponse[], string

---@class ReasonedResponse
---@field message string
---@field reasoning string

---@class IntroductoryPair
---@field en string
---@field ja string

ai = {} ---@type AI
